import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { TwoColumnGridContainer } from 'src/components/ui/TwoColumnGridContainer';
import { AccountNameField } from '../atomic-components/AccountNameField';
import { IBANField } from '../atomic-components/IBANField';
import { BICField } from '../atomic-components/BICField';

interface Props {
  disabled?: boolean;
}

export const PaymentDetails: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.payment.label')}>
      <TwoColumnGridContainer>
        <div>
          <AccountNameField />
          <BICField />
        </div>
        <div>
          <IBANField />
        </div>
      </TwoColumnGridContainer>
    </LaunchpadCard>
  );
};
